<template>
    <div class="row justify-content-center">
        <div class="col-xl-10">
            <div class="uploader-container">
                <div v-if="sended" class="compress-result component-sended--wrapper">
                    <div class="row row-min-height align-items-center">

                        <div class="col-12 text-center" v-show="!sendError && !completed">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">{{ trans('tool-main.Processing text') }}</span>
                            </div>
                            <h4>{{ trans('tool-main.Processing text') }}</h4>
                            <button class="btn btn-lg btn-info cancel-btn_tool" @click="cancelSendTask()">
                                {{ trans('tool-main.Cancel') }}
                            </button>
                        </div>
                        <div class="col-12" v-if="!sendError && completed">
                            <h2 class="title compress-result_title">{{ trans('tool-main.Image ready') }}</h2>
                            <div v-if="downloadUrl" class="mt-4">
                                <img class="image-block__small" :src="downloadUrl"/>
                            </div>

                            <div class="compress-result_action">
                                <div class="compress-result_action-group">
                                    <div class="compress-result_tools mt-4">
                                        <upload-block
                                            type-block="new-compact"
                                            :downloadUrl="downloadUrl"
                                            :dropboxFiles="dropboxFiles"
                                            :downloadFileInfo="downloadFileInfo"
                                            @onCancelDropbox="onCancelDropbox"
                                            @onErrorDropbox="onErrorDropbox"
                                            @onProgressDropbox="onProgressDropbox"
                                            @onSavedDropbox="onSavedDropbox"
                                            @markAsDownloaded="markAsDownloaded"
                                            ref="uploadBlock"/>

                                        <other-tools-block
                                            :task-id="this.taskId"
                                            :file-link="downloadUrl"
                                        ></other-tools-block>

                                        <div class="compress-result_tools-item">
                                            <button class="button compress-result_button-link"
                                                    @click="cancelSendTask()">
                                                {{ trans('tool-main.Keep Editing') }}
                                            </button>
                                            <button class="button compress-result_button-link" @click="reset()">
                                                {{ trans('tool-main.Start Over') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-stretch small_gutter">
                                <div class="col-lg-4 mt_25">
                                    <qr-block :url="downloadUrl"
                                              :task-id="taskId"
                                              :type="loaderType"
                                              :mode="loaderMode"
                                    ></qr-block>
                                </div>

                                <div class="col-lg-8 mt_25">
                                    <subscribe-block></subscribe-block>
                                    <share-icons-block></share-icons-block>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center" v-show="sendError">
                            <h5 class="mb-4" v-html="sendError">}</h5>
                            <button class="btn btn-outline-secondary ml-3" @click="reset()">
                                {{ trans('tool-main.Start Over') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="files.length === 0" class="file-uploader--wrapper">
                    <file-uploader
                        :type="loaderType"
                        :mode="loaderMode"
                        :multiple="false"
                        :maxFiles="1"
                        @files-uploaded="updateFiles($event)"
                    />
                </div>
                <div v-if="files.length > 0 && !sended"
                     class="component--wrapper component--wrapper__image-box-preview">
                    <div class="row">
                        <div class="col-12 text-center">
                            <div class="image-preview-wrapper" rel="imageWrapper" :style="wrapperStyles">
                                <img class="image-without-bg" :src="imageUrl"/>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row w-100 m-u justify-content-center">
                        <div class="col-md-4 p-u">
                            <label for="range_size">{{ trans('image/tool-sharpen.Strength label') }}</label>
                            <div class="float-right">{{ strength }}%</div>
                            <input id="range_size" v-model="strength" type="range" min="0"
                                   max="100" class="custom-range"/>
                        </div>
                        <div class="col-md-2 text-md-left p-u">
                            <button type="button" class="btn btn-primary ml-3" @click="checkAndSendTask()"
                                    :disabled="files.length < 1">{{ trans('image/tool-sharpen.Sharpen btn') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.subcomponent--wrapper.subcomponent--wrapper__image-box-preview {
    width: 100%;
}

.subcomponent--wrapper.subcomponent--wrapper__image-box-preview img {
    width: inherit;
}

.image-preview-wrapper {
    position: relative;
}

.bg-wrapper {
    overflow: hidden;
}

.image-preview-wrapper img {
    max-width: 600px;
    max-height: 400px;
    width: 100%;
    height: auto;
    object-fit: contain;
}

.image-without-bg {
    position: absolute;
    top: 0;
    left: 0;
}
</style>

<script>
import markAsDownloaded from '../mixins/mark-as-downloaded.js';
import baseProcessing from '../mixins/base-processing.js';

export default {
    props: [
        'loaderMode'
    ],
    mixins: [
        markAsDownloaded,
        baseProcessing,
    ],
    components: {
        'share-icons-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/ShareIconsBlock'),
        'subscribe-block'  : () => import(/* webpackChunkName: 'result-blocks' */ '../shared/SubscribeBlock'),
        'other-tools-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/OtherToolsBlock'),
        'file-uploader'    : () => import(/* webpackChunkName: 'fileuploader' */ '../uploader/FileUploader.vue'),
        'upload-block'     : () => import(/* webpackChunkName: 'uploadBlock' */ '../uploader/UploadBlock.vue'),
        'qr-block'         : () => import(/* webpackChunkName: 'qr-block' */ '../shared/QrBlock.vue'),
    },
    data() {
        return {
            files: [],
            step: 1,
            strength: 1,
            loaderType: 'image',
            imageUrl: null, //'https://dev.techjunkie-tools.com/storage/results/2022-04-11_08-43/image_blur_background/BtGs8x5qHiixqUoP/tinywow_blur_background_without_bg_1571.png',

            displayWidth: null,
            displayHeight: null,
            naturalWidth: null,
            naturalHeight: null,
        }
    },
    watch: {},
    computed: {
        wrapperStyles() {

            return {
                maxWidth: '600px',
                minHeight: '400px',
                margin: 'auto',
            };
        },
    },
    methods: {
        updateFiles(files) {
            this.files = files;
            this.imageUrl = this.files[0].url;
        },

        checkAndSendTask() {
            this.downloadUrl = null;
            Vue.nextTick(() => this.sendTask());
        },

        prepareTaskData() {
            this.taskUrl = '/' + this.loaderType + '/prepare';
            return {
                files: this.files,
                strength: this.strength,
                mode: this.loaderMode,
                step: this.step,
                task_id: this.taskId,
            };
        },

        successProcessing(response) {
            let result = response.data;

            this.state = result.state;
            this.progress = result.progress;

            if (this.state === 'completed') {
                clearInterval(this.interval);
                this.processing = false;
                this.completed = true;

                this.downloadUrl = result.download_url;
                this.downloadFileInfo.name = result.download_url.replace(/^.*[\\\/]/, '');
                this.dropboxFiles = [
                    {
                        'url': result.download_url,
                        'filename': result.download_url.replace(/^.*[\\\/]/, ''),
                    }
                ];
            }
        },

        afterReset() {
            // default values
            this.files = [];
            this.strength = 1;
            this.step = 1;
        },
    },
}
</script>
